import { BrowserRouter, Routes, Route } from "react-router-dom";
import "../src/styles/index.scss";
import React from "react";
import Home from "./Pages/Home";
import HeroesPage from "./Pages/HeroesPage";
import Gamemode from "./Pages/Gamemode";
import Error from "./Pages/Error";
import MapsPage from "./Pages/MapsPage";
import HeroDetails from "./Pages/HeroDetails";
import Carreer from "./Pages/Carreer";
import Teambuilder from "./Pages/Teambuilder";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/heroes' element={<HeroesPage />} />
        <Route path='/heroes/:id' element={<HeroDetails />} />
        <Route path='/gamemode' element={<Gamemode />} />
        <Route path='/maps' element={<MapsPage />} />
        <Route path="/carrier" element={<Carreer />} />
        <Route path="/builder" element={<Teambuilder />} />
        {/* <Route path="" element={<Error />} /> */}
        <Route path='*' element={<Error />} />
      </Routes>

    </BrowserRouter>
  );
}

export default App;
